import { Link } from "react-router-dom";
import { CalendarDays, ArrowUpRight } from "lucide-react";
import { useSettings } from "@/lib/api";

export const BookCallButton = ({ className = "btn-ghost-dark", testid = "book-call-btn", label = "Book a Discovery Call" }) => {
  const { booking_url } = useSettings();
  if (booking_url) {
    return (
      <a href={booking_url} target="_blank" rel="noopener noreferrer" className={className} data-testid={testid}>
        <CalendarDays className="h-4 w-4" /> {label} <ArrowUpRight className="h-4 w-4" />
      </a>
    );
  }
  return (
    <Link to="/contact?type=call" className={className} data-testid={testid}>
      <CalendarDays className="h-4 w-4" /> {label}
    </Link>
  );
};

export const AuditLink = ({ className = "btn-primary", testid = "audit-cta-btn", label = "Get Your Free Digital Audit", service }) => (
  <Link to={`/contact?type=audit${service ? `&service=${encodeURIComponent(service)}` : ""}`} className={className} data-testid={testid}>
    {label}
    <ArrowUpRight className="h-4 w-4" />
  </Link>
);
